<div [class.hidden]="_showPrintView" class="stats" [class.shown]="showStats">
  <app-mobility-widgets
    class="custom-scrollbar"
    [filter]="currentFilter"
    [stats]="mobilityStats"
    [legendTitle]="legendTitle"
    [legendSubtitle]="legendSubtitle"
    [compareMode]="compareMode"
    [compareLabels]="compareLabels"
    [legendColors]="getLegendColors()"
    [hideTargetWidgets]="!!poiDetail"
  >
    <!-- POI Detail widgets (from TanStack Query) -->
    <ng-container *ngIf="poiDetail">
      <app-stats-widget
        [infoTooltip]="globalAggsWidgetTooltip"
        *ngIf="poiReachWidgetData.length"
        [stats]="poiReachWidgetData"
      ></app-stats-widget>
      <app-stats-widget
        [infoTooltip]="trafficWidgetTooltip"
        *ngIf="poiTrafficWidgetData.length"
        [stats]="poiTrafficWidgetData"
      ></app-stats-widget>
      <app-pie-chart-widget
        class="gender"
        *ngIf="poiGenderData.length"
        title="{{ 'Gender distribution' | translate }} (%)"
        [data]="poiGenderData"
        [isMultiple]="!!comparePoiDetail"
        [labels]="compareLabels"
        unit="%"
        [colors]="[colorMen, colorWomen]"
        icon="/assets/img/icons/color/genders.svg"
        [highlight]="genderSelection"
      ></app-pie-chart-widget>
      <app-pyramid-widget
        *ngIf="poiAgeData.length"
        title="{{ 'Population distribution' | translate }} (%)"
        [data]="poiAgeData"
        [isMultiple]="!!comparePoiDetail"
        [labels]="compareLabels"
        unit="%"
        description="{{ '% by Age ranges, both genders' | translate }}"
        [highlight]="ageSelection"
      ></app-pyramid-widget>
      <app-bars-widget
        *ngIf="poiVisitorProfileData.length"
        title="{{ 'Number of reach by type' | translate }}"
        [data]="poiVisitorProfileData"
        [isMultiple]="!!comparePoiDetail"
        unit="%"
        formatNumber="1.0-1"
        [showZeros]="true"
        [highlight]="visitorProfileSelection"
      ></app-bars-widget>
    </ng-container>

    <!-- Legacy widgets (when POI detail not loaded) -->
    <ng-container *ngIf="!poiDetail">
      <app-stats-widget
        [infoTooltip]="globalAggsWidgetTooltip"
        *ngIf="globalAggsWidgetData.length"
        [stats]="globalAggsWidgetData"
      ></app-stats-widget>
      <app-stats-widget
        [infoTooltip]="trafficWidgetTooltip"
        *ngIf="trafficWidgetData.length"
        [stats]="trafficWidgetData"
      ></app-stats-widget>

      <app-bars-widget
        class="lowercase"
        *ngIf="hasTargetData('speed')"
        title="{{ 'Traffic speed' | translate }}"
        [data]="mobilityStats?.targetStats?.speed"
        unit="%"
        formatNumber="1.0-2"
        [isMultiple]="compareMode"
      ></app-bars-widget>
      <app-radar-chart-widget
        class="lowercase"
        *ngIf="hasTargetData('direction')"
        title="{{ 'Direction of movement' | translate }}"
        [data]="mobilityStats?.targetStats?.direction"
        [isMultiple]="compareMode"
        unit="%"
      ></app-radar-chart-widget>

      <app-bars-widget
        *ngIf="hasTargetData('fooddelivery_interested')"
        title="{{
          'pct. of Food delivery Apps Users by level of usage' | translate
        }}"
        [data]="mobilityStats?.targetStats?.fooddelivery_interested"
        [isMultiple]="compareMode"
        formatNumber="1.0-2"
        unit="%"
      >
      </app-bars-widget>

      <app-bars-widget
        *ngIf="hasTargetData('onlinebetplatforms_interested')"
        title="{{
          'pct. of Gambling Apps Users by level of usage' | translate
        }}"
        [data]="mobilityStats?.targetStats?.onlinebetplatforms_interested"
        formatNumber="1.0-2"
        unit="%"
      >
      </app-bars-widget>

      <app-bars-widget
        *ngIf="hasTargetData('transport_interested')"
        title="{{
          'pct. of Transport Apps Users by level of usage' | translate
        }}"
        [data]="mobilityStats?.targetStats?.transport_interested"
        [isMultiple]="compareMode"
        formatNumber="1.0-2"
        unit="%"
      >
      </app-bars-widget>
    </ng-container>
  </app-mobility-widgets>
</div>
<div [class.hidden]="_showPrintView" id="mapContainer">
  <app-map-hover-popup
    *ngIf="hoverPopupData.show"
    [style.top.px]="hoverPopupData.top"
    [style.left.px]="hoverPopupData.left"
    [data]="hoverPopupData.data"
    [tooltip]="hoverPopupData.tooltip"
    [primary]="hoverPopupData.primary"
    [showFrom]="hoverPopupData.showFrom"
    [compareMode]="tooltipCompareMode"
  >
  </app-map-hover-popup>
  <div style="display: none">
    <app-map-click-popup #mapClickPopup></app-map-click-popup>
  </div>

  <app-map
    #map
    *ngIf="mapBbox.length"
    [mapBbox]="mapBbox"
    [center]="mapCenter"
    [zoom]="mapZoom"
    [styles]="currentBasemap.value"
    [authorization]="getAuthorizationToken()"
    [attr.class]="currentBasemap.id"
    (mapLoaded)="onMapLoaded()"
  >
  </app-map>

  <div id="topLeftContainer">
    <div class="columnWrapper">
      <div
        class="filterWrapper"
        [class.hidden]="isCompareLoading || isPoisLoading"
      >
        <app-city-selector
          *ngIf="!isLoading && !selectedPOI"
          [ngClass]="{ both: !canShowCitySearch() }"
        >
        </app-city-selector>
        <app-selectfilter
          [title]="getFilterPlaceHolder()"
          [items]="poiList"
          [value]="currentSelectValue"
          *ngIf="canShowSelectFilter()"
          [attr.style]="brandIcon"
          (changeValue)="onPOISelected($event)"
          [canShowClear]="true"
        >
        </app-selectfilter>
        <div class="comparisonWrapper" [class.ready]="true">
          <app-selectfilter
            #compareSelectfilter
            *ngIf="
              showCompareFilterSelector &&
              selectedPOI &&
              (!selectedCompareDelivery || selectedComparePOI)
            "
            [title]="comparePlaceHolder | translate"
            [items]="filteredPoiList"
            [value]="currentCompareValue"
            [attr.style]="brandIcon"
            [compareMode]="true"
            (changeValue)="onPOICompareSelected($event)"
            (onOpen)="onOpenCompareSelector($event)"
            [canShowClear]="true"
          ></app-selectfilter>
        </div>
      </div>
      <app-map-controls
        [class.floating-widget]="mobilityStats?.aggregatedStats"
        [class.floating-collapsed]="floatBarCollapsed"
        [map]="map"
        *ngIf="mapLoaded"
        [basemapList]="basemapList"
        (basemapChanged)="changeBasemap($event)"
      ></app-map-controls>
      <app-footer></app-footer>
    </div>
    <app-map-loading
      *ngIf="
        isLoading || isPoiDetailLoading || isCompareLoading || isPoisLoading
      "
      [attr.class]="currentBasemap.id"
    ></app-map-loading>
    <app-summary
      *ngIf="
        !isLoading && !isPoiDetailLoading && !isCompareLoading && !isPoisLoading
      "
      [datasetName]="summaryName"
      [stats]="screenReachStats"
      [compareMode]="compareMode"
      [selectedCompareDelivery]="selectedCompareDelivery"
      [showContext]="!isFilterPanelShown"
      class="{{ currentBasemap.id }}"
      [class.poisComparation]="
        selectedComparePOI !== null && selectedComparePOI !== undefined
      "
    >
    </app-summary>
  </div>
  <app-campaign-creation-menu
    *ngIf="hasCampaignCreation && !selectedPOI"
    class="displaced"
    [class.closed-panel]="!isFilterPanelShown"
    [allPois]="allPois"
    [pois]="campaignPOIIds"
    [keyIndicator]="keyIndicator"
    [active]="campaignCreationActive"
    (onToggleActive)="activateCampaignCreation($event)"
    (onConfirm)="confirmCampaign()"
    (onClear)="clearCampaign()"
    (onEdit)="editCampaignPOIs($event)"
  >
  </app-campaign-creation-menu>
  <app-tag-selector
    class="displaced"
    *ngIf="!selectedPOI"
    [class.closed-panel]="!isFilterPanelShown"
    [stats]="globalReferenceAggs"
    [tags]="tagsList"
    [tagsSelected]="tagsSelected"
    (onTagsChange)="onTagsChange($event)"
    [minMaxSelected]="minMaxSelected"
    (onMinMaxChange)="onMinMaxChange($event)"
  ></app-tag-selector>
  <app-floating-widget
    *ngIf="
      mobilityStats?.aggregatedStats ||
      (selectedPOI && (isPoiDetailLoading || _aggregatedStatsLoading))
    "
    [title]="'Daytime traffic' | translate"
    [targets]="mobilityStats?.aggregatedStats || {}"
    [comparison]="compareOptions !== null"
    [loading]="
      isLoading ||
      isPoiDetailLoading ||
      isCompareLoading ||
      _aggregatedStatsLoading
    "
    (onCollapse)="onFloatWidgetCollapsed($event)"
  ></app-floating-widget>
  <app-map-attribute></app-map-attribute>
</div>
<app-filter-bar
  [class.hidden]="_showPrintView"
  (shownToggle)="onFilterPanelToggle($event)"
  (finishTogggleAnimation)="invalidateMapSize()"
  [showCompareDeliveries]="!showCompareFilterSelector || !selectedComparePOI"
  (deliveryToCompare)="deliveryToCompareSelected($event)"
></app-filter-bar>
<app-campaign-creation-modal
  *ngIf="showCampaignCreationModal"
  [pois]="poisForCreationModal"
  (onCancel)="showCampaignCreationModal = false"
  (onConfirm)="onCampaignSaved()"
></app-campaign-creation-modal>
